<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="属性" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="configCode">
              <a-input v-model="model.configCode" placeholder="请输入属性"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="属性名称" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="configName">
              <a-input v-model="model.configName" placeholder="请输入属性名称"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="属性类型" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="configType">
              <a-input v-model="model.configType" placeholder="请输入属性类型"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="是否生效" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="enabled">
              <j-switch v-model="model.enabled" :options="[1, 0]"></j-switch>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="值类型" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="valueType">
              <j-search-select-tag
                v-model="model.valueType"
                :dictOptions="valueTypeOptions"
                placeholder="请选择值类型"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              v-if="model.valueType === 'text'"
              label="属性值"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              prop="configValue"
            >
              <a-textarea placeholder="请输入属性值" rows="4" v-model="model.configValue" />
            </a-form-model-item>
            <a-form-model-item
              v-if="model.valueType === 'number'"
              label="属性值"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              prop="configValue"
            >
              <a-input-number placeholder="请输入属性值" style="width: 100%" v-model="model.configValue" />
            </a-form-model-item>
            <a-form-model-item
              v-if="model.valueType === 'switch'"
              label="属性值"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              prop="configValue"
            >
              <j-switch v-model="model.configValue" :options="[1, 0]"></j-switch>
            </a-form-model-item>
            <a-form-model-item
              v-if="model.valueType === 'image'"
              label="属性值"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              prop="configValue"
            >
              <j-image-upload class="absolute top-0" v-model="model.configValue"></j-image-upload>
            </a-form-model-item>
            <a-form-model-item
              v-if="model.valueType === 'file'"
              label="属性值"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              prop="configValue"
            >
              <j-upload v-model="model.configValue"></j-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="24" class="my-4">
            <a-form-model-item label="描述" :labelCol="labelCol2" :wrapperCol="wrapperCol2" prop="configDesc">
              <a-textarea v-model="model.configDesc" rows="4" placeholder="请输入描述" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'

export default {
  name: 'CommonSysSettingConfigForm',
  components: {},
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      model: {
        enabled: 1,
        valueType: 'text'
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      confirmLoading: false,
      validatorRules: {
        configCode: [{ required: true, message: '请输入属性!' }],
        configName: [{ required: true, message: '请输入属性名称!' }],
        valueType: [{ required: true, message: '请输入值类型!' }],
        valueValue: [{ required: true, message: '请输入属性值!' }]
      },
      valueTypeOptions: [
        { value: 'text', text: '文本' },
        { value: 'number', text: '数字' },
        { value: 'switch', text: '开关' },
        { value: 'file', text: '文件' },
        { value: 'image', text: '图片' }
      ],
      url: {
        add: '/system/setting/add',
        edit: '/system/setting/edit',
        queryById: '/system/setting/queryById'
      }
    }
  },
  computed: {
    formDisabled() {
      return this.disabled
    }
  },
  created() {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model))
  },
  methods: {
    add() {
      this.edit(this.modelDefault)
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
    },
    submitForm() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          httpAction(httpurl, this.model, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    }
  }
}
</script>
